// store.js
import { createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { combineReducers } from 'redux';

// Get Cart Item from Local Storage
const loadCartFromLocalStorage = () => {
  try {
    const serializedCart = localStorage.getItem('cartItems');
    if (serializedCart === null) {
      return undefined;
    }
    return JSON.parse(serializedCart);
  } catch (e) {
    console.warn("Could not load cart from localStorage", e);
    return undefined;
  }
};


// Reducer
const counterReducer = (state = { count: 0 }, action) => {
  switch (action.type) {
    case 'INCREMENT':
      return { count: state.count + 1 };
    case 'DECREMENT':
      return { count: state.count - 1 };
    default:
      return state;
  }
};



const userReducer = (state = { userObject: null }, action) => {
  
  switch (action.type) {
    case 'SET_USER_OBJECT':
      return { userObject: action.payload };
    case 'SET_USER':
      return { userObject: action.payload };
    case 'CLEAR_USER':
      return { userObject: null };
    default:
      return state;
  }
};

const initialCartState = {
  productCartItemData: loadCartFromLocalStorage() || [],
};

const productCartItemReducer = (state = initialCartState, action) => {
  
  switch (action.type) {
    
    case 'SET_PRODUCT_CART_ITEM':{
      const updatedCart = [...state?.productCartItemData, action?.payload?.newItem];
      localStorage.setItem('cartItems', JSON.stringify(updatedCart));
      return {
        ...state,
        productCartItemData: updatedCart, // Add new item to the array
      };
    }
    case 'UPDATE_PRODUCT_CART_ITEM': {
      const updatedCart = state.productCartItemData.map((item) => {
        if (item.id === action.payload.id) {
          return {
            ...item,
            quantity: action.payload.quantity, // only update quantity
          };
        }
        return item;
      });
    
      localStorage.setItem('cartItems', JSON.stringify(updatedCart));
    
      return {
        ...state,
        productCartItemData: updatedCart,
      };
    }
    case 'REPLACE_AND_ADD_PRODUCT_CART_ITEM': {
      const existingItemIndex = state.productCartItemData.findIndex(
        (item) => item.id === action.payload.id
      );
    
      let updatedCart;
    
      if (existingItemIndex !== -1) {
        updatedCart = [...state.productCartItemData];
        updatedCart[existingItemIndex] = action.payload;
      } else {
        updatedCart = [...state.productCartItemData, action.payload];
      }
    
      localStorage.setItem('cartItems', JSON.stringify(updatedCart));
    
      return {
        ...state,
        productCartItemData: updatedCart,
      };
    }
    
    case 'REMOVE_PRODUCT_CART_ITEM':{
      const updatedCart = state.productCartItemData.filter(
        (item) => item.id !== action.payload.id
      );
      localStorage.setItem('cartItems', JSON.stringify(updatedCart));
      return {
        ...state,
        productCartItemData: updatedCart,
      };
    }
    case 'CLEAR_PRODUCT_CART_ITEM':{
      localStorage.removeItem('cartItems');
      return {
        ...state,
        productCartItemData: [], // Clear the cart array
      };
    }
    default:
      return state;
  }
};

const showCartReducer = (state = { showCartPage: false }, action) => {
  
  switch (action.type) {
    case 'SET_SHOW_CART':
      return {
        ...state,
        showCartPage: action.payload.status, // Add new item to the array
      };
    case 'REMOVE_SHOW_CART':
      return {
        ...state,
        showCartPage: action.payload.status,
      };
    default:
      return state;
  }
};

const navigationReducer = (state = { navigationKey: null }, action) => {
  switch (action.type) {
    case 'SET_NAVIGATION_KEY':
      return {
        ...state,
        navigationKey: action.payload, 
      };
    default:
      return state;
  }
};
  
  const rootReducer = combineReducers({
    counter: counterReducer,
    user: userReducer,
    productCartItem: productCartItemReducer,
    showCart: showCartReducer,
    navigation: navigationReducer,
  });


const store = createStore(
  rootReducer,
  composeWithDevTools() 
);

export default store;
